<template>
  <div v-if="novaVersao" class="aviso-nova-versao" role="status">
    <i class="fas fa-sync-alt" />
    <span>
      Há uma nova versão do sistema. Recarregue a página para usar a versão
      atualizada.
    </span>
    <Button
      label="Recarregar"
      class="p-button-rounded p-button-sm"
      @click="recarregar()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useVersao } from "../../modules/versao";

/**
 * Aviso fixo de versão nova do front, com o botão de recarregar. A recarga automática (troca de
 * tela, volta para a aba sem modal aberto) está em modules/versao.ts e no router; este aviso
 * cobre quem fica parado numa tela com um formulário aberto.
 */
export default defineComponent({
  setup() {
    const { novaVersao, recarregar, iniciarVerificacaoVersao } = useVersao();
    onMounted(() => iniciarVerificacaoVersao());
    return { novaVersao, recarregar: () => recarregar() };
  }
});
</script>

<style scoped lang="scss">
.aviso-nova-versao {
  position: fixed;
  top: 0.75rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  max-width: calc(100vw - 2rem);
  padding: 0.6rem 1rem;
  border-radius: $radius-sm;
  background: $bg-surface;
  border: 1px solid $border-color;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);

  .p-button {
    margin: 0 !important;
    border-radius: $radius-sm !important;
    white-space: nowrap;
  }
}
</style>
